import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ASSETS } from "@/lib/assets";

const shots = [
  { src: ASSETS.setInterrogation, label: "Interrogation — Narrative Set", span: "md:col-span-7 md:row-span-2" },
  { src: ASSETS.portraitLowAngle, label: "On the Rig", span: "md:col-span-5" },
  { src: ASSETS.setWarehouseBulbs, label: "Warehouse Build", span: "md:col-span-5" },
  { src: ASSETS.setWarehouseOp, label: "Rolling", span: "md:col-span-5" },
  { src: ASSETS.heroPortrait, label: "V-Raptor [X] · ARRI Glass", span: "md:col-span-7" },
];

const reveal = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: (i % 3) * 0.08 } }),
};

export const OnSet = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["8%", "-8%"]);

  return (
    <section id="onset" data-testid="onset-section" ref={ref} className="py-28 sm:py-40 bg-[#050505] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-16 gap-6">
          <div>
            <p className="font-body text-xs uppercase tracking-[0.3em] text-gray-500 mb-4">The Work</p>
            <h2 className="font-head uppercase text-4xl sm:text-6xl tracking-tighter text-white leading-none">
              Behind The Frame<span className="text-[#D90429]">.</span>
            </h2>
          </div>
          <p className="font-body text-base text-gray-400 max-w-sm">
            Real sets, real gear, real stories. A glimpse from behind the lens on productions across Cape Town and beyond.
          </p>
        </div>

        <motion.div style={{ y }} className="grid grid-cols-1 md:grid-cols-12 gap-5 auto-rows-[220px] md:auto-rows-[240px]">
          {shots.map((s, i) => (
            <motion.figure
              key={i}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              data-testid={`onset-shot-${i}`}
              className={`group relative overflow-hidden border border-white/10 ${s.span}`}
            >
              <img
                src={s.src}
                alt={s.label}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent" />
              <figcaption className="absolute bottom-0 left-0 p-5">
                <span className="font-body text-xs uppercase tracking-[0.2em] text-white/80 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300">
                  {s.label}
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
